'use client';
import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  { id: 'faq-1', q: 'Who can participate in Motion Max Media Awards?', a: 'Any Indian citizen or resident above 16 years of age can participate. We welcome filmmakers, photographers, content creators, and digital storytellers at all experience levels.' },
  { id: 'faq-2', q: 'What is the entry fee?', a: 'The entry fee is ₹499 per submission. You may submit in multiple categories with a separate fee for each entry. Early bird discounts apply until 31 July 2026.' },
  { id: 'faq-3', q: 'What video formats and sizes are accepted?', a: 'We accept MP4, MOV, AVI, and MKV formats up to 2GB in size. Maximum video duration is configurable per category — typically 15 minutes for short films and 3 minutes for reels.' },
  { id: 'faq-4', q: 'How is judging conducted?', a: 'Each submission is evaluated by a panel of 3 independent judges on four criteria: Creativity, Technical Quality, Storytelling, and Presentation. Final scores are averaged and rankings computed.' },
  { id: 'faq-5', q: 'When will results be announced?', a: 'Shortlisted entries will be notified by 25 October 2026. The Grand Ceremony and final results announcement is scheduled for 15 November 2026 in Chennai.' },
  { id: 'faq-6', q: 'How do I receive my certificate?', a: 'All participants receive a digital Participation Certificate. Winners receive both digital and physical Winner Certificates mailed to their registered address within 30 days of the ceremony.' },
];

export default function FAQSection() {
  const [open, setOpen] = useState<string | null>('faq-1');

  return (
    <section id="faq" className="py-24 lg:py-32 bg-surface/20">
      <div className="divider-gold mb-24" />
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">FAQ</p>
          <h2 className="section-title text-foreground mb-4">
            Common <span className="gradient-gold-text">Questions</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs?.map((faq) => (
            <div key={faq?.id} className={`glass-card rounded-2xl overflow-hidden transition-all duration-300 ${open === faq?.id ? 'border-gold-subtle glow-gold-sm' : ''}`}>
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left"
                onClick={() => setOpen(open === faq?.id ? null : faq?.id)}
              >
                <span className="font-semibold text-sm text-foreground pr-4">{faq?.q}</span>
                <ChevronDown
                  size={18}
                  className={`text-primary flex-shrink-0 transition-transform duration-300 ${open === faq?.id ? 'rotate-180' : ''}`}
                />
              </button>
              {open === faq?.id && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-muted-foreground leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}